const state = {
  update: false,
  create: false,
  delete: false,
  type: '',
  comments_ids: []
}

const mutations = {
  TOGGLE_SOCKET_STATE (state, { type, value }) {
    state[type] = value
  },
  CLEAR_SOCKET_STATE (state) {
    state.update = false
    state.create = false
    state.create = false
  },
  SET_UPDATE_TYPE (state, type) {
    state.type = type
  },
  SET_UPDATE_COMMENT_IDS (state, comments_ids) {
    state.comments_ids = comments_ids
  }
}

export default {
  state,
  mutations
}
